var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckoutHeaderBackground = function SvgCheckoutHeaderBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 736 262"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M588.673-109.054C634-91 870.455-42.016 628.5-4.5 378.74 27.9 273.144 226.93 104.204 208.305c-275.405-30.362-305.789 97.632-305.789 37.326S-232.974-125.768-.049-125.768 325-195.5 588.673-109.054"
  })));
};
export default SvgCheckoutHeaderBackground;